import { CategoryActionsBodyCell } from './CategoryActionsBodyCell';
import { useActionsColumn } from '../../../../../../../components/columns/actions';

export function useCategoryActionsColumn() {
  return useActionsColumn({
    render: (text, row) => <CategoryActionsBodyCell row={row} />,
  });
}
